import { apiRequest } from '@/utils/api-request';

export const createOrganization = async <T = unknown>(name: string) => {
  const response = await apiRequest<T>({
    url: '/organizations',
    target: 'platform',
    method: 'POST',
    body: { name },
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to create organization' };
  }

  return response;
};
